import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Notification from "../../elements/notification/Notification";
import RetryCallbackButton from "../../elements/retryCallbackButton/RetryCallbackButton";
import GoToBackButton from "../../elements/goToBack/GoToBack";
import { useHistory } from "react-router-dom";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import PayoutDetailsContent from "./PayoutDetailsContent";
import { AppContext } from "../../../App";
import { useTranslation } from "react-i18next";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledPayoutDetailsWrapper } from "../styledPayout";
import { HTTP_STATUSES, PAYMENT_SYSTEM, STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { parseAxiosError } from "../../../utils/response";

const PayoutDetailsContainer = ({ match }) => {
  const { t } = useTranslation("transactionDetailsPage");
  const history = useHistory();

  const { user } = useContext(AppContext);

  let [payout, setPayout] = useState(null);
  const [transferUserEmail, setTransferUserEmail] = useState(null);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchPayout = async () => {
    let responsePayout = null;

    await axios.get("/api/payouts/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setPayout(response.data);
        responsePayout = response.data;
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });

    return responsePayout;
  };

  const fetchTransferDetails = (responsePayout) => {

    if(!responsePayout || responsePayout.paymentSystem.subName !== PAYMENT_SYSTEM.BALANCE_TRANSFER) {
      return;
    }

    axios.get(`/api/transfers?payout.referenceId=${responsePayout.referenceId}`, userAuthenticationConfig()).then(response => {
      if(response.status === HTTP_STATUSES.HTTP_OK && response.data['hydra:member'][0]) {
        setTransferUserEmail(response.data['hydra:member'][0]?.payment?.connection?.project?.user?.email);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  }

  const fetchPayoutTransactionOrPayoutTransfer = () => {
    fetchPayout().then(responsePayment => {
      fetchTransferDetails(responsePayment);
    });
  }

  useEffect(() => {
    fetchPayoutTransactionOrPayoutTransfer();
  }, []);

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.payoutTitle")}</title>
        </Helmet>
        <StyledPayoutDetailsWrapper>
          <div className="payout-details-head">
            <GoToBackButton
              handler={() => {history.goBack();}}
            />
            <RetryCallbackButton
              id={match.params.id}
              type="payouts"
              setNotification={setNotification}
              notification={notification}
            />
          </div>
          <PayoutDetailsContent payout={payout} transferUserEmail={transferUserEmail}/>
        </StyledPayoutDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default PayoutDetailsContainer;